/**
 * Sort object array
 * @param {Array} array [{..},{..}]
 * @param {String} target - Sort target key
 * @param {String} type - 'asc' or 'desc'
 * @returns {Array}
 */
export const sortObject = (array, target, type = 'asc') => {
  array.sort(function(a, b) {
    if (type === 'asc') {
      if (a[target] === null) return 1;
      if (b[target] === null) return -1;

      if (a[target] < b[target]) return -1;
      if (a[target] > b[target]) return 1;
      return 0;
    }

    if (type === 'desc') {
      if (a[target] === null) return -1;
      if (b[target] === null) return 1;

      if (a[target] > b[target]) return -1;
      if (a[target] < b[target]) return 1;
      return 0;
    }
  });

  return array;
};

/**
 * Sort by specifying the sort order (並び順を指定したソート)
 * @param array {array} - ['a', 'b'] or [{value: 'a'},{value: 'b'}]
 * @param key {string | null} - 対象のキー名 e.g.animal | null
 * @param order {array} - 並び順  e.g. ['dog', 'cat', 'horse']
 * @return {array}
 */
export const sortSpecifyOrder = (array, key, order) => {
  if (!array.length) return array;

  if (typeof array[0] !== 'object') {
    array.sort(function(a, b) {
      return order.indexOf(a) - order.indexOf(b);
    });
  } else {
    array.sort(function(a, b) {
      return order.indexOf(a[key]) - order.indexOf(b[key]);
    });
  }

  return array;
};
